export default "__VITE_ASSET__2c679a67__"